"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Silent = exports.UnMuted = exports.Muted = exports.ForcedMute = exports.NotApplicable = exports.AudioGroup = void 0;
const state_flow_1 = require("../state-flow");
//#endregion
//#region Group Declaration
// The group is responsible for the audio state management.
// If
exports.AudioGroup = state_flow_1.PlayerStateFlow.registerGroup("audio").bootstrap(() => {
    return (0, exports.NotApplicable)({ volume: 0.5 });
});
//#endregion
//#region Signals Handlers
function requestGesture({ audio }, signal) {
    if (audio.volume === 0) {
        return (0, exports.Muted)(audio);
    }
    return (0, exports.UnMuted)(audio);
}
function requestMute({ audio }, signal) {
    return (0, exports.Muted)(audio);
}
function requestUnMute({ audio }, signal) {
    return (0, exports.UnMuted)(audio);
}
function requestVolumeChange({ audio }, signal) {
    const volume = Math.min(Math.max(signal.volume, 0), 1);
    if (volume > 0) {
        return (0, exports.UnMuted)({ ...audio, volume });
    }
    return (0, exports.Muted)({ ...audio, volume });
}
//#endregion
//#region States Declarations
exports.NotApplicable = exports.AudioGroup.registerState("NotApplicable", {
    hostElementAttach: (g, s) => (0, exports.UnMuted)(g.audio),
});
exports.ForcedMute = exports.AudioGroup.registerState("ForcedMute", {
    hostElementDetach: (g, s) => (0, exports.NotApplicable)(g.audio),
    requestGesture,
    requestMute,
    requestUnMute,
});
exports.Muted = exports.AudioGroup.registerState("Muted", {
    hostElementDetach: (g, s) => (0, exports.NotApplicable)(g.audio),
    requestUnMute,
    requestVolumeChange,
});
exports.UnMuted = exports.AudioGroup.registerState("UnMuted", {
    hostElementDetach: (g, s) => (0, exports.NotApplicable)(g.audio),
    requestMute,
    requestVolumeChange,
});
exports.Silent = exports.AudioGroup.registerState("Silent", {
    hostElementDetach: (g, s) => (0, exports.NotApplicable)(g.audio),
    requestMute,
    requestUnMute,
    requestVolumeChange,
});
//#endregion
//# sourceMappingURL=audio.js.map